// src/components/AddClientModal.js
import React, { useState } from 'react';
import { API_URL } from "../config";

function AddClientModal({ onClose, onSave }) {
  const [name, setName] = useState('');
  const [contactInfo, setContactInfo] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      setError('Nazwa klienta jest wymagana');
      return;
    }
    try {
      const response = await fetch(`${API_URL}/clients`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ name, contact_info: contactInfo }),
      });
      if (!response.ok) throw new Error('Błąd dodawania klienta');
      onSave();
      onClose();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3>Dodaj Nowego Klienta</h3>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Nazwa klienta"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <input
            type="text"
            placeholder="Opis (niewymagane)"
            value={contactInfo}
            onChange={(e) => setContactInfo(e.target.value)}
          />
          {error && <p style={{ color: 'red' }}>{error}</p>}
          <div className="modal-buttons">
            <button type="submit" className="btn-submit">Zapisz</button>
            <button type="button" className="btn-submit" onClick={onClose}>Anuluj</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddClientModal;